import {Typography} from '@mui/material';
import {default as MuiMenuItem} from '@mui/material/MenuItem';
import {IDialogType} from 'common/names';
import {menuContext} from 'components/ContextMenu/context';
import React from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import selectors from 'redux/license/selectors';
import {Feature} from 'types/DiplomatFeature';

interface MenuItemProps {
   features?: Feature[];
   disabled?: boolean;
}

interface AcionMenuItemProps extends MenuItemProps {
   onClick: () => void;
   keepOpened?: boolean;
   name: string;
}
interface DialogMenuItemProps extends MenuItemProps {
   type: IDialogType;
   altName?: string;
}

const HeaderMenuItem = (props: AcionMenuItemProps | DialogMenuItemProps) => {
   const {handleClose} = React.useContext(menuContext);
   const isFeatureSupported = useSelector(selectors.isFeatureSupported);
   const navigate = useNavigate();

   const {type, features, disabled, altName} = props as DialogMenuItemProps;
   const isSupported = features ? features.some((feature) => isFeatureSupported(feature)) : true;

   if (!isSupported) {
      return null;
   }

   if (!handleClose) {
      throw new Error('Menu context is not provided');
   }

   if (type) {
      return (
         // <Link to={disabled ? null : `?dialog=${type.id}`}>
         <MuiMenuItem
            onClick={(ev) => {
               ev.nativeEvent.stopImmediatePropagation();
               ev.preventDefault();
               ev.stopPropagation();
               !keepOpened && handleClose(ev);
               navigate(`?dialog=${type.id}`);
               return false;
            }}
            disabled={disabled}
         >
            {altName || type.menuName}
         </MuiMenuItem>
         // </Link>
      );
   }

   const {onClick, keepOpened, name} = props as AcionMenuItemProps;
   return (
      <MuiMenuItem
         onClick={(ev) => {
            ev.nativeEvent.stopImmediatePropagation();
            ev.preventDefault();
            ev.stopPropagation();
            !keepOpened && handleClose(ev);
            onClick && onClick();
            return false;
         }}
         disabled={disabled}
      >
         <Typography>{name}</Typography>
      </MuiMenuItem>
   );
};

export default HeaderMenuItem;
